import GeoscapeDeveloperSvg from "icons/hub-logo-signIn.svg?react";
import { Spinner } from "components/ui/spinner";
import { useTheme } from "@/components/theme-provider";

export const ApplicationLoading = () => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  return (
    <div className="flex min-h-screen items-center justify-center overflow-auto">
      <div className="flex w-full max-w-sm flex-col items-center gap-10 py-10">
        <GeoscapeDeveloperSvg
          fill={isDark ? "white" : "black"}
          className="w-[80vw] max-w-sm h-[100px]"
        />
        <Spinner className="size-10" />
      </div>
    </div>
  );
};
